
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 50","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.567 50C7.013 41.96 16.79 36.577 28 36.577c11.21 0 20.987 5.383 26.433 13.423H1.567zm39.521-33.47c0 8.828-6.041 15.78-13.259 15.78-7.219 0-13.26-6.952-13.26-15.78 0-8.829 6.041-15.78 13.26-15.78 7.218 0 13.259 6.951 13.259 15.78z","fill-opacity":".25","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M.669 50C6.187 41.535 16.328 35.827 28 35.827c11.672 0 21.813 5.708 27.331 14.173h-1.807C48.157 42.387 38.747 37.327 28 37.327c-10.747 0-20.157 5.06-25.524 12.673H.669zm41.169-33.47C41.838 7.249 35.417 0 27.829 0c-7.589 0-14.01 7.249-14.01 16.53 0 9.281 6.421 16.53 14.01 16.53 7.588 0 14.009-7.249 14.009-16.53zm-1.5 0c0 8.376-5.661 15.03-12.509 15.03-6.849 0-12.51-6.654-12.51-15.03S20.98 1.5 27.829 1.5c6.848 0 12.509 6.654 12.509 15.03z"}})])
          )
        }
      }
    